//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters,mapActions } from "vuex";
import Model from '@/models/create'
export default {
    data() {
        return {
            visible: false,
            carTime: '',
            realityMoney: '',
            rules: {
                unParkNo: [
                    { required: true, message: '车场名称不能为空', trigger: 'blur' }
                ],
                carNo: [
                    { required: true, message: '车牌号码不能为空', trigger: 'blur' },
                    {
                        validator:(rule,value,callback) => {
                            let telReg = new RegExp(/^1(3|4|5|7|8)\d{9}$/),
                                carNoReg = new RegExp(/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳使领]{1}$/)
                            if(!carNoReg.test(value) && !telReg.test(value)) {
                                callback('请输入正确的车牌号或手机号')
                            }
                            callback()
                        },
                        trigger: 'blur'
                    }
                ],
                disMoney: [
                    { required: true, message: '优惠金额不能为空', trigger: 'blur' },
                    {
                        validator:(rule,value,callback) => {
                            if(value<0 || (value+'').indexOf('.')!=-1) {
                                callback('优惠金额必须大于0且不能为小数')
                            }
                            callback()
                        },
                        trigger: 'blur'
                    }
                ],
                // startTime: [
                //     { required: true, message: '请选择开始日期', trigger: 'blur' },
                //     {
                //         validator:(rule,value,callback) => {
                //             let nowTime = this.$moment({unit:'YYYY-MM-DD'}).valueOf(),
                //                 startTime = new Date(value).getTime(),
                //                 endTime = new Date(this.updateData.endTime).getTime();
                //             if(startTime>endTime) {
                //                 callback('开始日期不能大于结束日期')
                //             }
                //             if(startTime<nowTime) {
                //                 callback('开始日期不能小于今天')
                //             }
                //             callback()
                //         },
                //         trigger: 'blur'
                //     }
                // ],
                // endTime: [
                //     { required: true, message: '请选择结束日期', trigger: 'blur' },
                //     {
                //         validator:(rule,value,callback) => {
                //             let startTime = new Date(this.updateData.startTime).getTime(),
                //                 endTime = new Date(value).getTime();
                //             if(endTime<startTime) {
                //                 callback('结束日期不能小于开始日期')
                //             }
                //             callback()
                //         },
                //         trigger: 'blur'
                //     }
                // ]
            }
        }
    },
    computed:{
        ...mapGetters('create',{
            detail:'getDetail',
            carNoList: 'getCarNoList',
            parkList: 'getParkList'
        }),
        updateData(){
            return this.detail
        }
    },
    methods:{
        ...mapActions('create',{
            setDetailAction:'setDetailAction'
        }),
        getCarNo() {
            this.$parent.setCarNoListAction({ unParkNo: this.updateData.unParkNo })
        },
        async getCarTime() {
            const { unParkNo, carNo } = this.updateData
            if(!unParkNo || !carNo) return;
            let { data } = await Model.getCarNoTime({ carNo, unParkNo });
            if(data.success) {
                this.carTime = data.list.inTime;
                this.realityMoney = data.list.realityMoney;
            }
        },
        submit(){
            this.$refs.editForm.validate((err)=>{
                if(!err) return;
                this.setDetailAction(this.updateData)
                if(this.updateData.disAutoNo){
                    this.$parent.updateDiscount();
                }else{
                    this.$parent.addDiscount();
                }
            })
        }
    },
    created(){
        // let startTime=this.updateData.startTime,
        //     endTime=this.updateData.endTime
        // if(!startTime){
        //     this.updateData.startTime=this.$moment().format('YYYY-MM-DD')
        // }else{
        //     this.updateData.startTime=this.$moment(startTime).format('YYYY-MM-DD')
        // }
        // if(!endTime){
        //     this.updateData.endTime=this.$moment().add(1,'days').format('YYYY-MM-DD')
        // }else{
        //     this.updateData.endTime=this.$moment(endTime).add(1,'days').format('YYYY-MM-DD')
        // }
    }
}



// WEBPACK FOOTER //
// ./src/pages/create/Update.vue